@use '@design/design-tokens/typography/typography' as *;

.performance {
  @include typography-v2-body-xs;

  &.bullish {
    color: var(--viz-bullish);
  }

  &.bearish {
    color: var(--viz-bearish);
  }

  &.neutral {
    color: var(--text-default);
  }
}
